import { AssistantProcessStatus, validateAssistantProcesses } from "@models";
import { useQuery } from "@tanstack/react-query";
import { queryClient } from "@utils";
import { getAssistantProcessesQueryKey } from "../../config";
import { getAssistantProcesses } from "../../services";

export const getAssistantProcessesParams = ({
  orgId,
  deviceId,
  status: processStatus,
  enabled,
}: {
  orgId: string;
  deviceId: string;
  status?: AssistantProcessStatus;
  enabled?: boolean;
}) => {
  return {
    queryKey: getAssistantProcessesQueryKey(orgId, deviceId),
    queryFn: async () => {
      const { data, status } = await getAssistantProcesses(
        orgId,
        deviceId,
        processStatus
      );
      if (status !== 200) {
        return null;
      }
      const processes = await validateAssistantProcesses(data);
      return processes;
    },
    enabled,
  };
};

export const getAssistantProcessAsync = ({
  orgId,
  deviceId,
  status,
  enabled,
}: {
  orgId: string;
  deviceId: string;
  status?: AssistantProcessStatus;
  enabled?: boolean;
}) => {
  return queryClient.fetchQuery(
    getAssistantProcessesParams({ orgId, deviceId, status, enabled })
  );
};

export const useGetAssistantProcesses = ({
  orgId,
  deviceId,
  status,
  enabled,
}: {
  orgId: string;
  deviceId: string;
  status?: AssistantProcessStatus;
  enabled?: boolean;
}) => {
  return useQuery(
    getAssistantProcessesParams({ orgId, deviceId, status, enabled })
  );
};
